module.exports = __webpack_public_path__ + "media/images/pic/hero/sun-7e6dfcb91a68567950f8b5750002e404.webp";